import React from 'react';
import Square from '../square/square.js';
import '../index.css';

class Board extends React.Component {
  renderSquare(i) {
    // props value = i
    // props handleClick = onClick
    // Square = props now Square have value = i and event onClick = this.handleClick
    return (
      <Square
        value={this.props.squares[i]}
        onClick={() => this.props.onClick(i)}
      />
    );
  }

  render() {
    return (
      <div>
        <div className="board-row">
          {this.renderSquare(0)}
          {this.renderSquare(1)}
          {this.renderSquare(2)}
        </div>
        <div className="board-row">
          {this.renderSquare(3)}
          {this.renderSquare(4)}
          {this.renderSquare(5)}
        </div>
        <div className="board-row">
          {this.renderSquare(6)}
          {this.renderSquare(7)}
          {this.renderSquare(8)}
        </div>
      </div>
    );
  }
}

export default Board;


// WEBPACK FOOTER //
// ./src/board/board.js